export default "__VITE_ASSET__DBfwja64__"